module.exports = __webpack_public_path__ + "static/img/M3.aa602ace.png";